import React from 'react';
import Home from './containers/home/Home';
import Windy from './components/experiment/Windy';

import './App.css';

const App = () => {
  return (
    <>
      <Home />
      {/* <Windy /> */}
    </>
  );
};

export default App;
